module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-vodafonereb-00.1.12bb21b2.jpg";